const masks = {
  calendar: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    hour12: false,
    minute: '2-digit',
    second: '2-digit',
  },
  shortMonthDate: { month: 'numeric', day: 'numeric' }, // 'MM/dd',
};

// TODO: remove deprecated mapping once https://github.com/bellhops/booking-api/issues/585 is merged. https://github.com/bellhops/booking-ui/issues/1273
export const timezones = {
  'US/Alaska': 'America/Anchorage',
  'US/Aluetian': 'America/Adak',
  'US/Arizona': 'America/Phoenix',
  'US/Central': 'America/Chicago',
  'US/Eastern': 'America/New_York',
  'US/East-Indiana': 'America/Indiana/Indianapolis',
  'US/Hawaii': 'Pacific/Honolulu',
  'US/Indiana-Starke': 'America/Indiana/Knox',
  'US/Mountain': 'America/Los_Angeles',
  'US/Pacific': 'America/Anchorage',
  'US/Samoa': 'Pacific/Pago_Pago',
};

export const formatDate = (dateInt, zone, mask) => {
  const options = masks[mask] || masks.shortMonthDate;
  const dateVal = new Date(dateInt * 1000);
  const timeZone = timezones[zone] || zone;
  return dateVal.toLocaleString(Intl.DateTimeFormat().resolvedOptions().locale, {
    ...options,
    timeZone,
  });
};

export const formatCalendar = dateInt => {
  const options = masks.calendar;
  const dateVal = new Date(dateInt * 1000);
  const parts = Intl.DateTimeFormat(Intl.DateTimeFormat().resolvedOptions().locale, {
    ...options,
    timeZone: 'UTC',
  }).formatToParts(dateVal);

  const { year, month, day, hour, minute, second } = parts.reduce(
    (acc, part) => ({
      ...acc,
      [part.type]: part.value,
    }),
    {},
  );

  return `${year}${month}${day}T${hour}${minute}${second}Z`;
};

export const strScalarDate = date =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const scalarDate = (dateInt, zone, full) => {
  const dateVal = new Date(dateInt * 1000);
  const timeZone = timezones[zone] || zone;
  const initDateObj = dateVal.toLocaleString(Intl.DateTimeFormat().resolvedOptions().locale, {
    timeZone,
  });
  return full ? initDateObj : strScalarDate(new Date(initDateObj));
};

export const scalarTime = (int, zone, hour12 = false) =>
  new Date(int * 1000).toLocaleTimeString(Intl.DateTimeFormat().resolvedOptions().locale, {
    hour: 'numeric',
    minute: 'numeric',
    hour12,
    timeZone: timezones[zone] || zone,
  });
